import { collection, doc, setDoc, query, updateDoc, getDocs, where, getDoc } from "firebase/firestore";
import { uid } from "./login"
import { db } from "./firebase"
import { userObject } from '../store';



/**
 * Registers the user to Firebase depending on their selected role
 * @param {object} obj - Object containing all the properties of the user
 */
export async function registerUserInformation(obj){
    try{
        if (obj.constructor.name == "Physician"){

            const dr = await setDoc(doc(db, "/physicians", uid), {
                name: obj.name,
                cpso: obj.cpso,
                department: obj.department,
                hospital: obj.hospital,
                specialization: obj.specialization,
                billingReportEmail: obj.billingReportEmail,
                email: obj.email,
                role:(obj.constructor.name).toLowerCase(),
                uid: uid
            });
            // docFun doesn't throw an error
            const docFun = doc(db,`users/${uid}`)
            // this document isn't defined when
            const updateUser = await setDoc(doc(db,`users/${uid}`), {
                role:(obj.constructor.name).toLowerCase(),
                name: obj.name,
                cpso: obj.cpso,
                department: obj.department,
                hospital: obj.hospital,
                specialization: obj.specialization,
                billingReportEmail: obj.billingReportEmail,
                email: obj.email,
                uid: uid
            });
        }
        else if(obj.constructor.name == "Secretary"){
            const secretary = await setDoc(doc(db, "/secretaries", uid), {
                name: obj.name,
                department: obj.department,
                hospital: obj.hospital,
                physicians: obj.assignedPhysicians,
                role:(obj.constructor.name).toLowerCase(),
                uid: uid
            });
            for (let element of obj.assignedPhysicians){
                const secretaryPhysicianCollection = await setDoc(doc(db, "/secretaries", uid, "physicians", element.uid), {
                    name: element.name,
                    department: element.department,
                    hospital: element.hospital,
                    uid: uid
                });
            }
            const updateUser = setDoc(doc(db,`users/${uid}`), {
                role:(obj.constructor.name).toLowerCase(),
                name: obj.name,
                department: obj.department,
                hospital: obj.hospital,
                physicians: obj.assignedPhysicians,
                uid: uid
            });
        }

    }catch (error){
        alert(`Oh no! Something went wrong, please contact support@verusamb.com for 24/7 help.\nError: ${JSON.stringify(error)} in registerUserInformation()`)
    }
};



export async function returnAllUsersByRole(role){
    const docRef = query(collection(db, "users"), where("role", "==", role));
    const querySnapshot = await getDocs(docRef);
    let usersList = [];
    console.log('returnAllUsersByRole(): querySnapshot:', querySnapshot)

    switch (role){
        case "physician":
            querySnapshot.forEach((doc) => {
                // Pushing the data to usersList for all objects returned in querySnapshot
                usersList.push({
                    name: doc.data().name, 
                    cpso: doc.data().cpso, 
                    department: doc.data().department,
                    hospital: doc.data().hospital,
                    specialization: doc.data().specialization,
                    uid: doc.id, // Assuming uid is the document ID
                });
            });
            break;
        case "secretary":
            querySnapshot.forEach((doc) => {
                // Pushing the data to usersList for all objects returned in querySnapshot
                usersList.push({
                    name: doc.data().name, 
                    department: doc.data().department,
                    hospital: doc.data().hospital,
                    physicians: doc.data().assignedPhysicians,
                    uid: doc.id, // Assuming uid is the document ID
                });
            });
            break;
    }
    console.log(`List of ${role}:`, usersList);
    return usersList;
}




/**
 * Returns the object of a user.
 * @param {string} uid - User uid number
 * @returns {object} -  All the user information contained in an object
 */
export function getUserByUid(uid) {
    return new Promise(async (resolve, reject) => {
        try {
            const userRef = doc(db, "users", uid); // Correct way to get a document reference
            const docSnapshot = await getDoc(userRef);

            if (docSnapshot.exists()) {
                resolve(docSnapshot.data()); // Resolves with the user data if the document exists
                console.log(docSnapshot.data())
            } else {
                reject(new Error("User not found")); // Rejects the promise if the user document does not exist
            }
        } catch (error) {
            reject(error); // Rejects the promise if there's an error in the process
        }
    });
}


/**
 * Updates the details of an existing user in the database.
 * @param {object} user - An object containing the updated details of the user.
 * @returns {Promise<void>} A promise that resolves when the update operation is complete.
 */
export async function editUser(userObject) {
    try {
        const user = await getUserByUid(uid);
        let location;
        
        switch (user.role) {
            case "physician":
                location = "physicians";
                break;
            case "secretary":
                location = "secretaries";
                break;
            default:
                throw new Error(`Unsupported user role: ${user.role}`);
        }

        const docRef = doc(db, location, uid);
        const userRef = doc(db, "users", uid);

        // Convert userObject to a plain object if it's not already one
        const plainUserObject = JSON.parse(JSON.stringify(userObject));

        if (user.role == "secretary"){
            for (let element of userObject.assignedPhysicians){
                const secretaryPhysicianCollection = await setDoc(doc(db, "/secretaries", uid, "physicians", element.uid), {
                    name: element.name,
                    department: element.department,
                    hospital: element.hospital,
                    uid: uid
                });
            }
        }
 
        await setDoc(docRef, plainUserObject, { merge: true });
        await setDoc(userRef, plainUserObject, { merge: true });
    } catch (error) {
        console.error(error);
        throw new Error('Failed to update user: ' + error.message);
    }
}